"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("../object/isNil"));

var _getHashFromString = _interopRequireDefault(require("./getHashFromString"));

/**
 * Hashes some input and checks to see if that hash is in the boundPercentage percentage of "chosen" hashses
 *
 * @param inputString - string to turn in to a hash
 * @param boundPercentage - A float between 0 and 1 which represents the probability a hash has of being chosen
 * @returns boolean whether the input string was in the chosen set or not
 */
var hashIsWithinBounds = function hashIsWithinBounds(inputString) {
  var boundPercentage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (boundPercentage >= 1) return true;
  if (boundPercentage <= 0) return false;
  if ((0, _isNil["default"])(inputString)) return false;
  var hash = (0, _getHashFromString["default"])(inputString);
  var mod = hash % 100;
  return mod / 100 <= boundPercentage;
};

var _default = hashIsWithinBounds;
exports["default"] = _default;